const offsetInMilliseconds = new Date().getTimezoneOffset() * 60000;

export function getCurrentDate() {
  return new Date(Date.now() - offsetInMilliseconds).toISOString().split("T")[0];
}

export function getCurrentDateInUTC() {
  return new Date(Date.now()).toISOString().split("T")[0];
}

export function nowAsUTC() {
  return new Date().toISOString();
}

export function setNextRoundHourFromNowAsUTC() {
  const date = new Date();
  date.setMinutes(60, 0, 0);
  return date.toISOString();
}

export function getCurrentDayOfTheWeek() {
  const date = new Date();
  return date.toLocaleString("en", { weekday: "long" });
}

export function addMonthsToCurrentDate(numberOfMonths: number) {
  const now = new Date();
  return new Date(now.setMonth(now.getMonth() + numberOfMonths) - offsetInMilliseconds).toISOString().split("T")[0];
}

export function addMonthsToCurrentDateInUTC(numberOfMonths: number) {
  const now = new Date();
  return new Date(now.setMonth(now.getMonth() + numberOfMonths)).toISOString().split("T")[0];
}

export function addMonthsToNowInUTC(numberOfMonths: number) {
  const now = new Date();
  return new Date(now.setMonth(now.getMonth() + numberOfMonths)).toISOString();
}

export function substractMonthsFromNowInUTC(numberOfMonths: number) {
  const now = new Date();
  return new Date(now.setMonth(now.getMonth() - numberOfMonths)).toISOString();
}

export function convertDateToUnixTimestamp(date: string) {
  return new Date(date).getTime() + offsetInMilliseconds;
}

export function getNowAsTimestampString() {
  return new Date(Date.now() - offsetInMilliseconds).toISOString().replace(/[\D]/g, "");
}

export function formatDateToShortMonthFormat(date: string) {
  // Provided date will be formatted as "DD MMM, YYYY" i.e "12 Apr, 2022"
  const dateObj = new Date(date);
  const dayAsTwoDigit = dateObj.toLocaleString("en", { day: "2-digit" });
  const monthAsShort = dateObj.toLocaleString("en", { month: "short" });
  return `${dayAsTwoDigit} ${monthAsShort}, ${dateObj.getFullYear()}`;
}

export function formatDateToFullMonthFormat(date: string) {
  // Provided date will be formatted as "DD MMMM, YYYY" i.e "12 Apr, 2022"
  const dateObj = new Date(date);
  const dayAsTwoDigit = dateObj.toLocaleString("en", { day: "2-digit" });
  const monthAsShort = dateObj.toLocaleString("en", { month: "long" });
  return `${dayAsTwoDigit} ${monthAsShort}, ${dateObj.getFullYear()}`;
}

export function getDaysInCurrentMonth() {
  const date = new Date();
  const currentYear = date.getFullYear();
  const currentMonth = date.getMonth() + 1;
  return new Date(currentYear, currentMonth, 0).getDate();
}
